import React from 'react';

import { Oval } from 'react-loader-spinner';

import { useLoading } from '~/hooks/loading';

const Loading = () => {
  const { loading } = useLoading();

  return (
    <Oval
      height={80}
      width={80}
      // color="#4fa94d"
      color="#FFF4B2"
      wrapperStyle={{
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5',
      }}
      wrapperClass="spinner"
      visible={loading}
      ariaLabel="oval-loading"
      // secondaryColor="#4fa94d"
      secondaryColor="#FFD503"
      strokeWidth={2}
      strokeWidthSecondary={2}
    />
  );
};

export default Loading;
